import React, { Component } from 'react';
import banner from '../../assets/img/vector/monitoreo.svg';
import observium6 from '../../assets/img/software/observium6.png';
import observium7 from '../../assets/img/software/observium7.png';
import Section from '../../layout/Section';
import SectionContainer from '../../subcomponents/SectionContainer';
import MiniCarousel from '../../subcomponents/MiniCarousel';
import ImageText from '../../subcomponents/ImageText';
import TextImage from '../../subcomponents/TextImage';
import IconBlock from '../../subcomponents/IconBlock28';
import img1 from '../../assets/img/flat/monitoreo1.svg';
import img2 from '../../assets/img/flat/monitoreo2.svg';
import img3 from '../../assets/img/flat/monitoreo3.svg';
import observium from '../../assets/img/brand/observium.png';

class MonitoreoRed extends Component {
  componentDidMount() {
    document.title = 'Monitoreo de Red - Insacom';
    /* eslint-disable */
    $.HSCore.components.HSCarousel.init('.js-carousel');
  }

  render() {
    let iconBlocks = [
      {
        id: 1,
        title: 'Alertas',
        description: 'Customización de alertas a través de varias plataformas',
        img: img1
      },
      {
        id: 2,
        title: 'Reportes',
        description: 'Generación de reportes para apoyar la gestión de la red',
        img: img2
      },
      {
        id: 3,
        title: 'Plataforma Web',
        description: 'Sistema unificado en una plataforma web de fácil acceso',
        img: img3
      }
    ];

    const screenshots = [
      { title: 'Image 1', img: require('../../assets/img/software/observium1.png') },
      { title: 'Image 2', img: require('../../assets/img/software/observium2.png') },
      { title: 'Image 3', img: require('../../assets/img/software/observium3.png') },
      { title: 'Image 3', img: require('../../assets/img/software/observium3.png') },
      //{ 'title': 'Image 5', 'img': require('../../assets/img/software/observium5.png')},
    ];

    return (
      <Section asuntoContacto={'Monitoreo de Red'}>
        <SectionContainer paddingBottom={'0px'} backgroundColor="#94c6ed">
          <ImageText
            color="black"
            image={banner}
            title="Monitoreo de Red"
            description="Nuestro equipo siempre estará atento a los eventos de tu infraestructura; al mismo tiempo que podrás consultar métricas y estadísticas desde una interfaz moderna e intuitiva.">
            <div className="d-flex justify-content-between flex-wrap">
              <div className="align-self-center">
                <img src={observium} alt="Observium" style={{ height: '70px', paddingBottom: 20 }}></img>
              </div>
            </div>
          </ImageText>
        </SectionContainer>
        <SectionContainer>
          <IconBlock version={1} content={iconBlocks}></IconBlock>
        </SectionContainer>
        <SectionContainer grey>
          <TextImage
            image={observium6}
            title="Características"
            description="Posibilidad de configurar alertas personalizadas con distintos criterios, adaptables a tus necesidades.">
            <p className="mb-5"></p>
            <ul className="list-unstyled g-font-size-13 mb-0">
              <li>
                <i className="d-inline-block g-color-primary mr-2 mb-3 fa fa-check"></i>
                Sistema en la nube.
              </li>
              <li>
                <i className="d-inline-block g-color-primary mr-2 mb-3 fa fa-check"></i>
                Instalación y mantenimiento soportado por INSACOM.
              </li>
              <li>
                <i className="d-inline-block g-color-primary mr-2 mb-3 fa fa-check"></i>
                Moderna e intuitiva interfaz.
              </li>
              <li>
                <i className="d-inline-block g-color-primary mr-2 mb-3 fa fa-check"></i>
                Monitoreo en tiempo real de uso de Ancho de banda.
              </li>
              <li>
                <i className="d-inline-block g-color-primary mr-2 mb-3 fa fa-check"></i>Alertas mediante E-Mail y Telegram ®.
              </li>
            </ul>
          </TextImage>
        </SectionContainer>
        <SectionContainer>
          <ImageText
            image={observium7}
            title="Monitoreo Proactivo"
            description="Plataforma de monitoreo de red de bajo mantenimiento y auto-descubrimiento que soporta una amplia gama de tipos de dispositivos, plataformas y sistemas operativos, incluyendo Cisco, Windows, Linux, HP, Juniper, Dell, FreeBSD, Brocade, Netscaler, NetApp y muchos más. Se centra en proporcionar una interfaz hermosa y poderosa pero simple e intuitiva para la salud y el estado de su red.">
          </ImageText>
        </SectionContainer>
        <SectionContainer>
          <MiniCarousel content={screenshots}></MiniCarousel>
        </SectionContainer>
      </Section>
    );
  }
}

export default MonitoreoRed;



// WEBPACK FOOTER //
// ./src/sections/ti/MonitoreoRed.js